import {
  createSelector
} from 'reselect'
import * as R from 'ramda'
import P from 'helpers/predicates'

import {
  REPORT_FIELDS
} from './constants'
import {
  entitySelector
} from 'containers/Entity/selectors'

const skuSelector = (state) => state.report.weeklystatus.sku
const searchSelector = (state) => state.report.weeklystatus.search
const tableFilterSelector = (state) => state.report.weeklystatus.tableFilter
const tableSortSelector = (state) => state.report.weeklystatus.tableSort
const reportDurationValueSelector = (state) => state.report.weeklystatus.reportDuration.value
const reportDurationWeekSelector = (state) => state.report.weeklystatus.reportDuration.week
const reportDurationYearSelector = (state) => state.report.weeklystatus.reportDuration.year

const skuSourceSelector = createSelector(
  entitySelector,
  R.compose(
    R.fromPairs,
    R.map(({
      name
    }) => [name, name]),
    R.ifElse(
      R.isNil,
      R.always([]),
      R.values
    ),
    R.prop('product_children_views')
  )
)

const predicates = (query) => R.compose(
  R.anyPass,
  R.map(field => R.compose(
    R.contains(query),
    R.toLower,
    R.toString,
    R.prop(field)
  ))
)(REPORT_FIELDS)

const reportSourceSelector = createSelector(
  entitySelector,
  searchSelector,
  (entities, search) => R.compose(
    R.filter(predicates(search)),
    R.project(REPORT_FIELDS),
    R.sortWith([
      R.descend(R.prop('workYear')),
      R.descend(R.prop('workWeek')),
      R.descend(R.prop('PartnerSite'))
    ]),
    R.ifElse(
      R.isNil,
      R.always([]),
      R.values
    ),
    R.prop('project_weekly_update_report_views')
  )(entities)
)

export {
  skuSelector,
  searchSelector,
  tableFilterSelector,
  tableSortSelector,
  skuSourceSelector,
  reportSourceSelector,
  reportDurationValueSelector,
  reportDurationWeekSelector,
  reportDurationYearSelector
}